import styled from 'styled-components'

const StyledUploadContent = styled.div`
  margin: ${props => (props.compact ? '0 18px' : '0')};
}`

export default StyledUploadContent
